exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"white": "#ffffff",
	"gray": "#949494",
	"grayDark": "#464646",
	"grayLight": "#e9e9e9",
	"black": "#000000",
	"blue": "#0075c9",
	"blueDark": "#0064ab",
	"blueLessLight": "#087eb7",
	"orange": "#e26c00",
	"red": "#ff0000"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./app/styles/colors.css
// module id = 2
// module chunks = 0